import {useMemo, useState} from 'react';
import * as css from './SeatmapManage.css';
import {ARMCHAIR_ICON} from './seatIcons';

// LEGACY assign popup (.popup-add-ticket): "שינוי/הוספת כרטיסים ל- N מושבים
// שנבחרו" — replace is single-select, add (מושב מרובה כרטיסים) is multi-select;
// a ticket already on ALL the selected seats is excluded from the list.
function AssignTicketPopup({act, selectedSeats, tickets, eid, busy, onSave, onClose}) {
    const [picked, setPicked] = useState(new Set());

    const counter = useMemo(() => {
        const c = {};
        for(const s of selectedSeats) for(const tid of s.tids || []) c[tid] = (c[tid] || 0) + 1;
        return c;
    }, [selectedSeats]);

    const list = useMemo(() => tickets.filter((t) => (counter[t.tid] || 0) < selectedSeats.length), [tickets, counter, selectedSeats]);

    const toggle = (tid) => {
        setPicked((prev) => {
            const next = new Set(act === 'replace' ? [] : prev);
            if(prev.has(tid)) next.delete(tid); else next.add(tid);
            return next;
        });
    };

    const head = `${act === 'replace' ? 'שינוי' : 'הוספת'} כרטיסים ל- ${selectedSeats.length} מושבים שנבחרו`;

    return (
        <css.assignPop onClick={onClose}>
            <css.assignBox onClick={(e) => e.stopPropagation()}>
                <div className="head">
                    <span>{head}</span>
                    <span className="x" onClick={onClose}>✕</span>
                </div>
                <div className="sub">בחרו כרטיס מהרשימה</div>
                <div className="list">
                    {list.map((t) => (
                        <css.assignItem key={t.tid} $on={picked.has(t.tid)} onClick={() => toggle(t.tid)}>
                            <css.emSwatch $color={`#${(t.color || '').replace('#', '') || '93c5fd'}`}>
                                <img src={ARMCHAIR_ICON} alt="" />
                            </css.emSwatch>
                            <span className="title">{t.title}</span>
                            <span className="cnt">{counter[t.tid] || 0}<p>כרטיסים</p></span>
                            <span className="price">₪{t.price}</span>
                        </css.assignItem>
                    ))}
                    {!list.length && <div style={{padding: 16, fontSize: 13, color: '#94a3b8'}}>אין כרטיסים נוספים לשיוך.</div>}
                </div>
                <div className="foot">
                    <css.assignBtn onClick={() => { window.open(`${window.location.origin}/e/${eid}/tickets?act=open`, '_blank'); }}>כרטיס חדש</css.assignBtn>
                    <css.assignBtn className="primary" disabled={busy || !picked.size}
                        onClick={() => onSave(Array.from(picked))}>שמור מקומות</css.assignBtn>
                </div>
            </css.assignBox>
        </css.assignPop>
    );
}

export default AssignTicketPopup;
